import { styled } from '@mui/material/styles';
import React from 'react';
import {
  CellLayout,
  CellLayoutRow,
  CellLayoutSecondaryTypography,
  CellLayoutPrimaryTypography,
} from './CellLayout';
import { TableTooltip } from 'src/common/components/Tooltip/TableTooltip';
import { StickyCopyExtension } from 'src/common/StickyCopyExtension/StickyCopyExtension';

type IconTextCellProps = {
  value: string;
  subValue: string;
  icon?: React.ReactNode;
  subIcon?: React.ReactNode;
};

const ValueRow = styled('div')({
  display: 'flex',
});

const Icon = styled('div')({
  flex: 1,
  marginLeft: 4,
});

export const IconTextCell = ({ value, subValue, icon, subIcon }: IconTextCellProps) => {
  return (
    <CellLayout>
      <CellLayoutRow>
        <StickyCopyExtension value={value || ''}>
          <TableTooltip value={value || ''}>
            <ValueRow>
              <CellLayoutPrimaryTypography>{value || '-'}</CellLayoutPrimaryTypography>
              <Icon>{icon}</Icon>
            </ValueRow>
          </TableTooltip>
        </StickyCopyExtension>
      </CellLayoutRow>
      <CellLayoutRow>
        <StickyCopyExtension value={subValue || ''}>
          <TableTooltip value={subValue || ''}>
            <ValueRow>
              <CellLayoutSecondaryTypography>{subValue || '-'}</CellLayoutSecondaryTypography>
              <Icon>{subIcon}</Icon>
            </ValueRow>
          </TableTooltip>
        </StickyCopyExtension>
      </CellLayoutRow>
    </CellLayout>
  );
};
